import React, { forwardRef, useEffect, useImperativeHandle, useLayoutEffect, useRef, } from 'react';
import { CnModal } from '@/components/cn-modal';
import { usePropsValue } from '@/utils/use-props-value';
import { mergeProps } from '@/utils/with-default-props';
import { Wrapper } from './wrapper';
import { useShouldRender } from './should-render';
import { useClickAway } from 'ahooks';
import { normalizePlacement, } from './normalize-placement';
const classPrefix = 'cn-ui-m-modal';
const defaultProps = {
    placement: 'top',
    defaultVisible: false,
    // stopPropagation: ['click'],
    getContainer: () => document.body,
};
const Popover = forwardRef((p, ref) => {
    const props = mergeProps(defaultProps, p);
    const { mode = 'light', className, style } = props;
    const placement = normalizePlacement(props.placement);
    const modalRef = useRef();
    const [visible, setVisible] = usePropsValue({
        value: props.visible,
        defaultValue: props.defaultVisible,
        onChange: props.onVisibleChange,
    });
    useImperativeHandle(ref, () => {
        return {
            show: () => setVisible(true),
            hide: () => setVisible(false),
            visible,
        };
    }, [visible]);
    const targetRef = useRef(null);
    useLayoutEffect(() => {
        modalRef?.current?.floating_update(targetRef);
    });
    useEffect(() => {
        if (!targetRef?.current?.element)
            return;
        if (!props.trigger)
            return;
        function handleClick() {
            setVisible((v) => !v);
        }
        targetRef?.current?.element.addEventListener('click', handleClick);
        return () => {
            targetRef?.current?.element?.removeEventListener('click', handleClick);
        };
    }, [targetRef?.current?.element, props.trigger]);
    useClickAway(() => {
        if (!props.trigger)
            return;
        setVisible(false);
    }, [() => targetRef.current?.element, modalRef.current?.floatingRef], ['click', 'touchmove']);
    const shouldRender = useShouldRender(visible, true, props.destroyOnHide);
    return (React.createElement(React.Fragment, null,
        React.createElement(Wrapper, { ref: targetRef }, props.children),
        shouldRender && (React.createElement(CnModal, { visible: visible, ref: modalRef, floating_mode: mode, floating_content: props.content, isFloatingUI: true, placement: placement, className: className, styleProp: style, containerClassName: `${classPrefix}-popover`, container: props.getContainer() }))));
});
Popover.displayName = 'CnPopover';
export { Popover as CnPopover };
